module.exports = __webpack_public_path__ + "jwplayer.flash.swf";


/*****************
 ** WEBPACK FOOTER
 ** ./~/file-loader?name=jwplayer.flash.swf!./vendor/jwplayer.flash.swf
 ** module id = 5
 ** module chunks = 0
 **/